import userSaga from './Account/sagas';


function* mySaga() {
  // eslint-disable-next-line max-len
  // @ts-ignore - Type 'Generator<ForkEffect<never>, void, unknown>' is not an array type or a string type. Use compiler option '--downlevelIteration' to allow iterating of iterators.
  yield* userSaga();
}

export default mySaga;
